window.addEventListener("DOMContentLoaded",function(){
    var devices = {
        smallDevices: 576,
        mediumDevices: 768,
        largeDevices: 992,
        extraLargeDevices: 1200,
        smallDevicesDown: 576 - 1,
        mediumDevicesDown: 768 - 1,
        largeDevicesDown: 992 - 1,
        extraLargeDevicesDown: 1200 - 1,
    };

    var checkMediaQuery = function (deviceWidth, direction) {
        var string = direction == 'up' ? 'min-width' : 'max-width';
        var resultMatch = window.matchMedia('(' + string + ': ' + deviceWidth + 'px)');
        return resultMatch ? resultMatch.matches : null;
    };

    if (checkMediaQuery(devices.mediumDevices, 'up')) {
        var menuItems=document.querySelectorAll(".bls__menu-parent");

        HoverIntent(menuItems,{
                onEnter:function(e){
                console.log('hola acá')
                    document.querySelector('.bls__overlay').classList.remove('d-none-overlay')
                    //getAttribute()
                    if(e.getAttribute('data-no-overlay')){
                        document.querySelector(e.getAttribute('data-no-overlay')).style.zIndex=9;
                    }
                },
                onExit:function(e){
                    document.querySelector('.bls__overlay').classList.add('d-none-overlay')
                    if(e.getAttribute('data-no-overlay')){
                        document.querySelector(e.getAttribute('data-no-overlay')).style = {};
                    }
                }
            }
        )
    }
})

